// Pertahanan kedua setelah validasi skema di backend: apa pun yang bukan http(s) tidak pernah
// dijadikan href, supaya javascript:/data: tidak bisa dieksekusi dari kartu tautan.
export function safeUrl(u) {
  try {
    const p = new URL(String(u || ""));
    return p.protocol === "http:" || p.protocol === "https:" ? p.href : null;
  } catch {
    return null;
  }
}
